import React from 'react';
import { styled } from '@mui/material';
import { Colors } from 'library';
import { BaseButton } from 'library/ui';

export type ReviewOptionTone = 'positive' | 'negative' | 'neutral';

const SELECTED_BG: Record<ReviewOptionTone, string> = {
    positive: Colors.secondary,
    negative: Colors.error,
    neutral: Colors.primary,
};

export default function ReviewOptionButton({
    selected,
    tone,
    onClick,
    children,
}: {
    selected: boolean;
    tone: ReviewOptionTone;
    onClick: () => void;
    children: React.ReactNode;
}) {
    return (
        <Toggle $selected={selected} $tone={tone} onClick={onClick}>
            {children}
        </Toggle>
    );
}

const Toggle = styled(BaseButton, {
    shouldForwardProp: (prop) => prop !== '$selected' && prop !== '$tone',
})<{ $selected: boolean; $tone: ReviewOptionTone }>(({ $selected, $tone }) => ({
    padding: '8px 16px',
    borderRadius: 24,
    fontSize: 14,
    fontWeight: 500,
    backgroundColor: $selected ? SELECTED_BG[$tone] : Colors.fill,
    color: $selected ? Colors.white : Colors.primary,
    '&:hover:not(:disabled)': { opacity: 0.85 },
}));
